import { connect } from "react-redux";

import Component from "./Component";
import { updateGameData as updateGameDataForList } from "domain/GamesSearch/actions";
import { updateGameData as updateGameDataForPage } from "domain/Game/actions";
import {getGameById} from "domain/Game/selectors";

const MapStateToProps = (state, { gameId }) => {
    return {
        game: getGameById(state, gameId),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateGameData: (id, gameData) => {
            dispatch(updateGameDataForList(id, gameData));
            dispatch(updateGameDataForPage(id, gameData));
        },
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Component);
